import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";
import Imageurldata from "../../../../Imageurldata";

import Button from "../../../../component/Button/Button";
import { Col, Row, Modal } from "react-bootstrap";
import InputText from "../../../../component/InputText/InputText";

import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import config from "../../../../config/config";

const expinyearsOptions = [
  {
    name: "",
  },
  {
    name: "Months",
  },
  {
    name: "Years",
  },
];

const Stores = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [exptabshow, setExptabshow] = useState(false);
  const [textline1, settextline1] = useState("");
  const [title, settitle] = useState("");
  const [oldLogoTitle, setoldLogoTitle] = useState("");
  const [newLogoTitle, setnewLogoTitle] = useState("");
  const [oldLogoDescription, setoldLogoDescription] = useState("");
  const [newLogoDescription, setnewLogoDescription] = useState("");
  const [textline1err, settextline1err] = useState("");
  const [filename, setfilename] = useState("");
  const [link, setlink] = useState("");
  const [linkerr, setlinkErr] = useState("");
  const [city, setcity] = useState("");
  const [state, setstate] = useState("");
  const [zip, setzip] = useState("");
  const [phone, setphone] = useState("");
  const [maplink, setmaplink] = useState("");
  const [lat, setlat] = useState("");
  const [long, setlong] = useState("");
  const [name, setname] = useState("");
  const [addr, setaddr] = useState("");
  const [bannerimg, setbannerimg] = useState("");
  const [bannerimgerr, setbannerimgErr] = useState("");
  const [bannerimgnotpresent, setbannerimgnotpresent] = useState("");
  const [type, settype] = useState("Add");
  const [mbbannerimg, setmbbannerimg] = useState("");
  const [mbbannerimgerr, setmbbannerimgErr] = useState("");
  const [mbImgNotPresent, setmbImgNotPresent] = useState("");
  const [isupdate, setisupdate] = useState(false);
  const [updateModel, setUpdateModel] = useState(false);
  const [showMobImg, setShowMobImg] = useState("");
  const [showDesktopImg, setShowDesktopImg] = useState("");

  const base_url = config.api_url;

  const [bannerid, setbannerid] = useState("");

  const [toastlist, setToastList] = useState([]);

  let toastProperties = null;

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);
    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: `Store ${
            updateModel ? "updated" : "added"
          } Successfully`,
          backgroundColor: "#329F33",
          icon: check,
        };
        break;
      case "danger":
        toastProperties = {
          id,
          title: "Something Went Wrong",
          description: "",
          backgroundColor: "red",
          icon: close,
        };
        break;
      case "delete":
        toastProperties = {
          id,
          title: "Success",
          description: "Store deleted Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      default:
        setToastList([]);
    }

    setToastList([...toastlist, toastProperties]);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setisupdate(false);
    setUpdateModel(false);
    setShow(true);
    setShowMobImg(false);
    setShowDesktopImg(false);
    settitle("");
    settype("Add");
    settextline1("");
    setoldLogoDescription("");
    setoldLogoTitle("");
    setnewLogoDescription("");
    setnewLogoTitle("");
    setlink("");
    setbannerimg("");
    setmbbannerimg("");
  };
  const deleteAll = () => {
    axios({
      method: "post",
      url: `${base_url}store/stores/delete-all`,
      //withCredentials: true,
    })
      .then((response) => {
        console.log(response);
        const templist = response.data.reverse();
        setList(templist);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        //showToast("danger");
      });
  };
  useEffect(() => {
    setLoading(true);

    let url = new URL(urldata + "admin/getBannerImages");
    axios({
      method: "get",
      url: `${base_url}store/stores`,
      //withCredentials: true,
    })
      .then((response) => {
        console.log(response);
        const templist = response.data.reverse();
        setList(templist);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        //showToast("danger");
      });
  }, []);

  const handleShowForUpdate = (rowData) => {
    setisupdate(true);
    console.log(rowData);
    setUpdateModel(true);
    setShow(true);
    settype("Update");
    setname(rowData.name);
    setaddr(rowData.address);
    setcity(rowData.city);
    setstate(rowData.state);
    setzip(rowData.zip);
    setphone(rowData.phone);
    setmaplink(rowData.mapLink);
    setlat(rowData.latitude);
    setlong(rowData.longitude);
    //setlink(rowData.buttonLink);{ title: "Name", field: "name" },

    // setmbbannerimg(Imageurldata + rowData.mobileImageUrl.replaceAll("\\","/"))
    // setbannerimg(Imageurldata + rowData.desktopImageUrl.replaceAll("\\","/"))
    // setmbImgNotPresent(rowData.mobileImageUrl.replaceAll("\\","/") ? false: true)
    // setbannerimgnotpresent(rowData.desktopImageUrl.replaceAll("\\","/") ? false: true)

    setbannerid(rowData._id);

    setShowMobImg(false);
    setShowDesktopImg(false);
  };

  const updateBanner = () => {
    var formData = new FormData();
    formData.append("name", name);
    formData.append("address", addr);
    formData.append("city", city);
    formData.append("state", state);
    formData.append("zip", zip);
    formData.append("phone", phone);
    formData.append("mapLink", maplink);
    formData.append("latitude", lat);
    formData.append("longitude", long);

    if (mbImgNotPresent) {
      formData.append("mobileImageUrl", mbbannerimg);
      setmbImgNotPresent(false);
    }

    if (bannerimgnotpresent) {
      formData.append("desktopImageUrl", bannerimg);
      setbannerimgnotpresent(false);
    }

    let url = new URL(urldata + "admin/updateBannerImages");
    formData.append("id", bannerid);
    //url.searchParams.append('id', bannerid)
    var decoded = decodeURIComponent(url);

    axios({
      method: "post",
      url: `${base_url}store/stores/update`,
      data: formData,
      //withCredentials: true,/banner/udpate
    })
      .then((response) => {
        const templist = response.data.reverse();
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        console.log("error--", error);
        setShow(false);
        // showToast("danger");
      });
  };

  const createbanner = () => {
    var formData = new FormData();
    formData.append("oldLogoDescription", oldLogoDescription);
    formData.append("oldLogoTitle", oldLogoTitle);
    formData.append("newLogoDescription", newLogoDescription);
    formData.append("newLogoTitle", newLogoTitle);
    formData.append("title", title);
    formData.append("buttonLink", link);
    formData.append("screen", "home");
    formData.append("mobileImageUrl", mbbannerimg);
    formData.append("desktopImageUrl", bannerimg);

    let url = new URL(urldata + "admin/addBannerImages");

    axios({
      method: "post",
      url: `${base_url}store/stores/new`,
      data: formData,
      // withCredentials: true,
    })
      .then((response) => {
        // settextline1("");
        // settextline2("");
        // settextline3("");
        // setlink("");
        // setbannerimg("");
        // setmbbannerimg("");
        setShow(false);
        showToast("success");
        console.log(response);
        const templist = response.data.reverse();
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        // showToast("danger");
      });
  };

  const submit = () => {
    var formIsValid = true;
    // if (!bannerimg) {
    //   formIsValid = false;
    //   setbannerimgErr("*Please upload desktop banner image.");
    // } else {
    //   setbannerimgErr("");
    // }

    // if (!mbbannerimg) {
    //   formIsValid = false;
    //   setmbbannerimgErr("*Please upload mobile  banner image.");
    // } else {
    //   setmbbannerimgErr("");
    // }

    // <<<<<<< HEAD
    // if (bannerimg) {
    //   if (bannerimg.size / 1024 > 300) {
    //     formIsValid = false
    //     setbannerimgErr("*File should be less than 300Kb.");
    //   }
    // }
    // if (mbbannerimg) {
    //   if (mbbannerimg.size / 1024 > 300) {
    //     formIsValid = false
    //     setmbbannerimg("*File should be less than 300Kb.");
    //   }
    // }

    // ======= https://laxmihos.com/api
    // >>>>>>> vijay
    if (formIsValid) {
      if (updateModel) {
        updateBanner();
      } else {
        createbanner();
      }
    }
  };

  const deleteBtnClick = (id) => {
    setLoading(true);
    let data = {};
    data.id = id;

    let url = new URL(urldata + "admin/deleteBannerImage");

    axios({
      method: "post",
      url: `${base_url}store/stores/delete`,
      data: data,
      // withCredentials: true,
    })
      .then((response) => {
        //   showToast("success");
        //   props.onHide(); props.history.push('/admin/login')

        const templist = response.data.reverse();
        setList(templist);
        setLoading(false);
        showToast("delete");
      })
      .catch((error) => {
        // showToast("danger");
        setLoading(false);
      });
  };

  if (loading) {
    return (
      <div id="wrapper">
        <div className="profile-main-loader">
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#ed1c24"
                stroke-width="2"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="addjobinlist text-right mb-4">
        <Button title="Delete all" onClick={deleteAll} />
        <Button title="Add Store" onClick={handleShow} />
      </div>
      <MaterialTable
        title="Store's List"
        columns={[
          { title: "Name", field: "name" },
          { title: "Address", field: "address" },
          { title: "City", field: "city" },
          { title: "State", field: "state" },
          { title: "Zip Code", field: "zip" },
          { title: "Phone No.", field: "phone" },
          { title: "Google Map", field: "mapLink" },
          { title: "Latitude", field: "latitude" },
          { title: "Longitude", field: "longitude" },

          {
            field: "url",

            title: "Action  ",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title=" Update"
                  onClick={() => {
                    handleShowForUpdate(rowData);
                  }}
                ></Button>
                <Button
                  title=" Delete"
                  onClick={() => deleteBtnClick(rowData._id)}
                ></Button>
              </div>
            ),
          },
        ]}
        data={list}
        options={{
          exportButton: true,
          actionsColumnIndex: -1,
        }}
      />

      <Modal
        {...props}
        //   size="lg"
        //   aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="addbannerModel"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="model">
          {isupdate && (
            <div>
              <div className="title">{type} Store</div>

              <Row>
                <Col lg={3} className="column">
                  <div className="titleitem">{type} Name </div>
                </Col>
                <Col lg={9} className="column">
                  <input
                    value={name}
                    onChange={(e) => setname(e.target.value)}
                    // maxlength="31"
                    type="text"
                  />
                </Col>
                <Col lg={3} className="column">
                  <div className="titleitem">{type} address </div>
                </Col>
                <Col lg={9} className="column">
                  <input
                    value={addr}
                    onChange={(e) => setaddr(e.target.value)}
                    // maxlength="31"
                    type="text"
                  />
                </Col>
                <Col lg={3} className="column">
                  <div className="titleitem">{type} city </div>
                </Col>
                <Col lg={9} className="column">
                  <input
                    value={city}
                    onChange={(e) => setcity(e.target.value)}
                    // maxlength="31"
                    type="text"
                  />
                </Col>
                <Col lg={3} className="column">
                  <div className="titleitem">{type} state </div>
                </Col>
                <Col lg={9} className="column">
                  <input
                    value={state}
                    onChange={(e) => setstate(e.target.value)}
                    // maxlength="31"
                    type="text"
                  />
                </Col>
                <Col lg={3} className="column">
                  <div className="titleitem">{type} zip </div>
                </Col>
                <Col lg={9} className="column">
                  <input
                    value={zip}
                    onChange={(e) => setzip(e.target.value)}
                    // maxlength="31"
                    type="text"
                  />
                </Col>
                <Col lg={3} className="column">
                  <div className="titleitem">{type} phone </div>
                </Col>
                <Col lg={9} className="column">
                  <input
                    value={phone}
                    onChange={(e) => setphone(e.target.value)}
                    // maxlength="31"
                    type="text"
                  />
                </Col>
                <Col lg={3} className="column">
                  <div className="titleitem">{type} map link </div>
                </Col>
                <Col lg={9} className="column">
                  <input
                    value={maplink}
                    onChange={(e) => setmaplink(e.target.value)}
                    // maxlength="31"
                    type="text"
                  />
                </Col>
                <Col lg={3} className="column">
                  <div className="titleitem">{type} latitude </div>
                </Col>
                <Col lg={9} className="column">
                  <input
                    value={lat}
                    onChange={(e) => setlat(e.target.value)}
                    // maxlength="31"
                    type="text"
                  />
                </Col>
                <Col lg={3} className="column">
                  <div className="titleitem">{type} longitude </div>
                </Col>
                <Col lg={9} className="column">
                  <input
                    value={long}
                    onChange={(e) => setlong(e.target.value)}
                    // maxlength="31"
                    type="text"
                  />
                </Col>
              </Row>
            </div>
          )}
          {!isupdate && (
            <div>
              <div className="title">Add category</div>

              <Row>
                <Col lg={3} className="column">
                  <div className="titleitem">Add Excel File</div>
                </Col>
                <Col lg={9} className="column">
                  <input
                    id="bannerImage"
                    type="file"
                    onChange={(e) => {
                      console.log(e.target.files[0].name);
                      setbannerimg(e.target.files[0]);
                      setfilename(e.target.files[0].name);
                      setbannerimgnotpresent(true);
                    }}
                    name="passport_proof_upload"
                  />
                  <label for="bannerImage" className="d-f" id="file-drag">
                    <img src={upload} class="img-fluid" />
                    <div class="chooseTxt">Choose File</div>
                  </label>
                  <div>{bannerimg !== "" && filename}</div>
                  <div></div>
                </Col>
              </Row>
            </div>
          )}
          <div className="btnContainer mt-4">
            <Button onClick={submit} title="SUBMIT" />
          </div>
        </Modal.Body>
      </Modal>
      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default Stores;

// updateBannerImages
